import { render, staticRenderFns } from "./SuccessAnimationIcon.vue?vue&type=template&id=35838b72&scoped=true&"
var script = {}
import style0 from "./SuccessAnimationIcon.vue?vue&type=style&index=0&id=35838b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35838b72",
  null
  
)

export default component.exports